import {useParams} from 'react-router-dom';

import {getNwIdSearchString} from '../../state/workspaces/url';
import * as urls from '../../util/urls';

export const useSingleRunBackUrl = () => {
  const {entityName, projectName, groupName, sweepName} = useParams<{
    entityName: string;
    projectName: string;
    groupName?: string;
    sweepName?: string;
  }>();

  let baseUrl: string;
  if (groupName) {
    baseUrl = urls.runGroup({
      entityName,
      projectName,
      name: groupName,
      tab: 'workspace',
    });
  } else if (sweepName) {
    baseUrl = urls.sweep({entityName, projectName, sweepName});
  } else {
    baseUrl = urls.project({entityName, name: projectName});
  }

  const nwIdSearch = getNwIdSearchString();
  return baseUrl + nwIdSearch;
};
